import React, { useState, useEffect } from 'react'
import { FormControl, MenuItem, Box, TextField } from '@material-ui/core';
import PlotService from '../../services/PlotService';
import { useStore } from '../../Store'
import { findPlot } from '../../utils';
import LocationMap from '../LocationMap';
import { amersfoort2graden } from '../../utils/location'

const LocationPicker = ({onSelect, plots, plot, setPlot}) => {
    const [startFolder, setStartFolder] = useState('')
    const [regionFolder, setRegionFolder] = useState('')
    const [startFolders, setStartFolders] = useState([])
    const [regionFolders, setRegionFolders] = useState([])
    const [locationFolders, setLocationFolders] = useState([])
    const [search, setSearch] = useState('')
    const [position, setPosition] = useState(amersfoort2graden(155000, 463000))
    const [zoom, setZoom] = useState(8)

    const { addPlot } = useStore()

    useEffect(async () => {
        // initialisatie
        const response = await PlotService.getStartFolders()
        const folders= response.data.sort((a,b) => a.folderTypeId > b.folderTypeId ? 1 : -1)
        setStartFolders(folders)
        const location= findPlot(plots, plot)
        let start= ''
        if (location) {
            const folderTypeId= location.folderTypeId-2;
            start= folders.find(f => f.folderTypeId===folderTypeId).id
        } else {
            start= (folders.length > 0 ? folders[0].id : '')
        }
        await startFolderChanged(start, location)
    }, [])

    useEffect(() => {
        const timeoutid= setTimeout(() => {
            if (startFolder) startFolderChanged(startFolder)
        }, 500)
        return () => clearTimeout(timeoutid)
    }, [search])

    const startFolderChanged = async (start, location) => {
        setStartFolder(start)
        const response = await PlotService.getRegionFolders(start, search)
        const folders= response.data.sort((a,b) => a.description > b.description ? 1 : -1)
        setRegionFolders(folders)
        let region= ''
        if (location) {
            region= location.parentId
            location.Parent= folders.find(f => f.id === location.parentId)
        } else {
            region= (folders.length > 0 ? folders[0].id : '')
        }
        await regionFolderChanged(start, region, location)
    }

    const regionFolderChanged = async (start, region, location) => {
        setRegionFolder(region)
        const folder= (location?location.Parent:regionFolders.find(f => f.id === region))
        if (folder && folder.extraInfo.zoom) {
            setPosition([folder.extraInfo.lat, folder.extraInfo.long])
            setZoom(folder.extraInfo.zoom)
        } else {
            setPosition(amersfoort2graden(155000, 463000))
            setZoom(8)
        }
        const response = await PlotService.getLocations(start, region, search)
        const folders= response.data.sort((a,b) => a.description > b.description ? 1 : -1)
        setLocationFolders(folders)

    }

    const handleSelect= (selected) => {
        if (!plots.find(p => p.id === selected)) {
            // add plot to plots list in store
            addPlot(locationFolders.find(p => p.id === selected))
            setPlot(selected, false)
        } else {
            setPlot(selected, true)
        }
        onSelect() ;// close the dialog
    }

    return (
        <>
            <Box m={2} style={{height:'calc(100vh - 300px)'}}>
                <FormControl fullWidth={true}>
                    <TextField
                        select
                        label="MOO of LIMP"
                        id="select_start"
                        value={startFolder}
                        onChange={(e) => startFolderChanged(e.target.value)}>
                        {startFolders.map((item, i) => (<MenuItem value={item.id} key={item.id}>{item.description}</MenuItem>))}
                    </TextField>
                </FormControl>
                <FormControl fullWidth={true}>
                    <TextField
                        label="Zoek locatie"
                        id="search"
                        placeholder="type een (deel) van de locatienaam"
                        value={search}
                        type="search"
                        onChange={(e) => setSearch(e.target.value)}>
                    </TextField>
                </FormControl>
                <FormControl fullWidth={true}>
                    <TextField
                        select
                        label="Regio"
                        id="select_regio"
                        value={regionFolder}
                        onChange={(e) => regionFolderChanged(startFolder, e.target.value)}>
                        {regionFolders.map((item, i) => (<MenuItem value={item.id} key={item.id}>{item.description}</MenuItem>))}
                    </TextField>
                </FormControl>
                <LocationMap onSelect={handleSelect} plots={locationFolders} zoom={zoom} position={position} />
            </Box>
        </>
    )
}

export default LocationPicker
